var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "my-tag-input",
    class: _vm.classes,
    on: {
      click: _vm.focus
    }
  }, [_c("div", {
    ref: "tags",
    staticClass: "el-select__tags"
  }, [_vm.collapseTags && _vm.tags.length ? _c("span", [_c("Tag", {
    attrs: {
      type: "info",
      size: _vm.tagSize,
      closable: _vm.closableTag,
      "disable-transitions": ""
    },
    on: {
      close: function close($event) {
        return _vm.removeTag(0);
      }
    }
  }, [_vm._v(_vm._s(_vm.tags[0]))]), _vm.tags.length > 1 ? _c("Tag", {
    attrs: {
      closable: false,
      type: "info",
      size: _vm.tagSize,
      "disable-transitions": ""
    }
  }, [_c("span", {
    staticClass: "el-select__tags-text"
  }, [_vm._v("+ " + _vm._s(_vm.tags.length - 1))])]) : _vm._e()], 1) : _vm._e(), !_vm.collapseTags ? _c("span", _vm._l(_vm.tags, function (item, index) {
    return _c("Tag", {
      key: index,
      attrs: {
        type: "info",
        size: _vm.tagSize,
        closable: _vm.closableTag,
        "disable-transitions": ""
      },
      on: {
        close: function close($event) {
          return _vm.removeTag(index);
        }
      }
    }, [_vm._v(_vm._s(item) + " ")]);
  }), 1) : _vm._e(), _vm.allowCreate ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    ref: "input",
    staticClass: "el-select__input",
    style: _vm.inputStyle,
    attrs: {
      type: "text",
      disabled: _vm.disabled,
      readonly: _vm.readonly
    },
    domProps: {
      value: _vm.query
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.select.apply(null, arguments);
      },
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.query = $event.target.value;
      }
    }
  }) : _vm._e()]), _c("ElInput", {
    ref: "reference",
    attrs: {
      size: _vm.size,
      "suffix-icon": _vm.icon,
      disabled: _vm.disabled,
      readonly: _vm.readonly,
      placeholder: _vm.showPlaceholder
    },
    on: {
      focus: _vm.focus
    }
  }), false ? _c("Select") : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };